import 'flowbite';

import "./src/styles/global.css"
import './src/state/i18n';


import wrapWithProvider from "./src/state/wrap-with-provider"

export const wrapRootElement = wrapWithProvider